/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'ajs-legacy';
const componentName = 'virtualservice-security-ddos-full-list';
const prefix = `${moduleName}.${componentName}`;

export const noAttacksToDisplayMessage = `${prefix}.noAttacksToDisplayMessage`;
export const doneButtonLabel = `${prefix}.doneButtonLabel`;

export const ENGLISH = {
    [noAttacksToDisplayMessage]: 'No attacks to display.',
    [doneButtonLabel]: 'Done',
};
